import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
    <div style={{ textAlign: 'center' }}>
      <div className="spinner" style={{
        width: '50px', height: '50px', border: '4px solid #E2E8F0',
        borderTopColor: '#2C7A7B', borderRadius: '50%', animation: 'spin 1s linear infinite',
        margin: '0 auto 1rem'
      }} />
      <p style={{ color: '#5A6E7F' }}>{message}</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  </div>
);

export default LoadingSpinner;